<template>
<div id="index">
  <!-- <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
  <v-notificationTop :noticeInfo="noticeInfo" ></v-notificationTop>
  <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header> -->
  <div  id="runTaskDiv" >
   
  </div>
  <!-- <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>
  <v-backToTop></v-backToTop> -->
</div>
</template>
<script>

import { mapState } from 'vuex'
// import * as dd from 'dingtalk-jsapi' 
// import {fosun_oapi_login} from '../../assets/js/fosun_oapi_login-2.0.0_v2.js'
// import fosun_server_return from '../../assets/js/fosun_server_return.js'

export default {
  data () {
    return {
      webConfigInfo:{},
      paramInfo:{},
      yellowPage:"",
      footerColumnInfos:[],
      warehousingUrl:"",
      navigationColumnInfos:[],
      hitSearchUrl:'',
      enterpriseResourceBaseUrl:'',
      yellowPageColumn:{},
      productAndSolutionColumn:{},
      loading:true,
      runRecuritUrl:'',
      noticeInfo:[],
      showMessage:'',
      loginFlag:false,
      redirectUrl:'',
      userInfo:{},
      companyInfo:{},
      messageNumber:'',
      redirectURL:'',
      responseInfo:{},
      showFlag:false,
      hiddenContent:'',
      currentResponseInfo:{}


    }
  },
  computed: mapState([
    'KP'
  ]),
  components: {

  },
  watch: {
    // 如果 `question` 发生改变，这个函数就会运行
    // $route(to,from){
    //   alert(to);
    // }
  },   
  created () {
    let query = this.$route.query;
    alert("asasasas"+query.responseInfo);
    
  },
  methods:{
    jump(url){
      window.location.href = url;
    }
  }
}
</script>

<style scoped lang="stylus">
@media only screen and (max-width: 766px)
  .games
    display: none
</style>



// WEBPACK FOOTER //
// src/pages/loginError/index.vue